import React from "react";
import { Flex, Text, IconButton, Heading, Box } from "@radix-ui/themes";
import { CodeIcon } from "@radix-ui/react-icons";

interface CardHeaderProps {
  title: string;
  subtitle?: string;
  showApiCall?: boolean;
  onApiCallToggle?: () => void;
  showApiToggle?: boolean;
}

export default function CardHeader({
  title,
  subtitle,
  showApiCall = false,
  onApiCallToggle,
  showApiToggle = false,
}: CardHeaderProps) {
  return (
    <Flex justify="between" align="start" style={{ minHeight: "32px" }}>
      <Flex direction="column" gap="1" style={{ flex: 1 }}>
        <Heading size="4" weight="bold" color="gray" highContrast>
          {title.toUpperCase()}
        </Heading>
        {subtitle && (
          <Text size="1" color="gray">
            {subtitle}
          </Text>
        )}
      </Flex>
      {showApiToggle && onApiCallToggle && (
        <Box style={{ flexShrink: 0, marginLeft: "16px" }}>
          <IconButton
            variant={showApiCall ? "solid" : "ghost"}
            size="2"
            onClick={(e) => {
              e.stopPropagation();
              onApiCallToggle?.();
            }}
            style={{ marginTop: "-2px" }}
          >
            <CodeIcon />
          </IconButton>
        </Box>
      )}
    </Flex>
  );
}
